import { render } from "./CarImagesDetail.vue?vue&type=template&id=4e2624f5"
import script from "./CarImagesDetail.vue?vue&type=script&lang=js"
export * from "./CarImagesDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__